import { BANNERS } from "./banners";
import {
  Banner,
  BannersWrapper,
  DescriptionParagraph,
  DescriptionTitle,
  GifWrapper,
  DescriptionWrapper,
  Wrapper,
} from "./styles";
import home from "../../../../assets/pages/NewHome/home.png";
import React from "react";

function RentJourneySection() {
  return (
    <Wrapper>
      <GifWrapper autoPlay muted loop>
        <source
          src={require("../../../../assets/pages/Home/mudanca-animada.webm")}
        />
      </GifWrapper>
      <DescriptionWrapper>
        <DescriptionTitle>
          Sua Jornada de aluguel, feita para você
        </DescriptionTitle>
        <DescriptionParagraph>
          Facilitamos o aluguel com simplicidade e contratos digitais.
        </DescriptionParagraph>
        <BannersWrapper>
          {BANNERS.map((banner) => (
            <Banner key={banner.title}>
              <img src={banner.image} alt="Imagem do banner" loading="lazy" />
              <h6>{banner.title}</h6>
              <p>{banner.content}</p>
            </Banner>
          ))}
        </BannersWrapper>
      </DescriptionWrapper>
    </Wrapper>
  );
}

export default RentJourneySection;
